import { Box, BoxProps, IconNew, ModBox, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'
import { SUCCESS_CODE } from '../../../network/DomesticMoneyTransfer/transferAmount'

interface FundTransferStatusProps {
  state: 'pending' | 'fulfilled' | 'rejected' | undefined
  data: any
  onPress: any
}

const STATUS_DETAILS = {
  SUCCESS: {
    message: 'Fund Transfer Successful',
    bgColor: 'DISMANTLED_GREEN',
    borderColor: 'GREEN',
    iconId: 'TICKMARK',
  },
  FAILED: {
    message: 'Fund Transfer Failed',
    bgColor: '#F6C5C5',
    borderColor: 'ERROR',
    iconId: 'CLOSE',
  },
  PENDING: {
    message: 'Fund Transfer Pending',
    bgColor: 'WHITE',
    borderColor: 'BORDER_PENDING',
    iconId: 'ICON_REFRESH_CIRCLE',
  },
}

export const FundTransferStatus = ({ state, data, onPress }: FundTransferStatusProps) => {
  const getTransactionStatus = () => {
    if (data?.responseCode === SUCCESS_CODE) {
      return data?.responseData?.transactions?.[0]?.status
    } else if (data?.isTimeoutError) {
      return 'PENDING'
    }
    return 'FAILED'
  }
  console.log('htag', getTransactionStatus(), data)

  const rrnNo = getRRNNo(data)

  return (
    <ModBox
      show={['fulfilled', 'rejected'].includes(state)}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'row'}>
      <StatusIcon status={getTransactionStatus()} onPress={onPress} />
      <SpacerNew direction="horizontal" size={8} />
      <Box>
        <TextNew {...styles.textNew}>
          {STATUS_DETAILS[getTransactionStatus()]?.message ?? getTransactionStatus()}
        </TextNew>
        {rrnNo && <TextNew {...styles.textNew}>{`RRN No: ${rrnNo}`}</TextNew>}
      </Box>
    </ModBox>
  )
}

export const getRRNNo = (resp) => resp?.transactions?.[0]?.rrn || resp?.responseData?.transactions?.[0]?.rrn || resp?.responseData?.rrn

const styles = {
  textNew: {
    fontSize: 12,
    color: 'BLACK_75',
    fontFamily: 'jioType-medium',
  } as TextNewProps,
  statusIconContainer: (status) =>
    ({
      width: 30,
      height: 30,
      borderRadius: 30,
      borderWidth: 1,
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: STATUS_DETAILS?.[status]?.borderColor,
      backgroundColor: STATUS_DETAILS?.[status]?.bgColor,
    } as BoxProps),
}

const StatusIcon = ({ status, onPress }) => {
  return (
    <Box {...styles.statusIconContainer(status)} onPress={status === 'PENDING' ? onPress : undefined}>
      <IconNew id={STATUS_DETAILS?.[status]?.iconId} color={STATUS_DETAILS?.[status]?.borderColor} size={22} />
    </Box>
  )
}
